import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_SITE_MANAGER_MONITORING_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSiteManagerMonitoring = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_SITE_MANAGER_MONITORING_API(projectId)}`);
};

const useGetSiteManagerMonitoring = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-site-manager-monitoring", projectId],
    queryFn: () => getSiteManagerMonitoring(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetSiteManagerMonitoring;
